<template>
  <table class="table table-sm table-borderless m-0 table-unstriped">
    <tbody>
      <tr v-for="(row, rowIndex) in groups" :key="rowIndex">
        <td v-for="(notification, notificationIndex) in row" :key="notificationIndex">
          <icon :name="notificationCheckIcon(notification)" size="11"></icon>
          <small>{{notification.name}}</small>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Icon from '@/components/Icon'
import Permissions from '@/lib/permissions'

export default {
  name: 'TeamTabs',
  props: ['notifications', 'columns'],
  components: { Icon },
  computed: {
    groups () {
      var lists = []
      for (var i = 0; i < this.availableNotifications.length; i++) {
        if (i % this.columns === 0) {
          lists.push([this.availableNotifications[i]])
        } else {
          lists[lists.length - 1].push(this.availableNotifications[i])
        }
      }
      return lists
    },
    availableNotifications () {
      return Permissions.emailNotifications
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    notificationCheckIcon (notification) {
      if (this.notifications.indexOf(notification.id) === -1) {
        return 'cross'
      } else {
        return 'check'
      }
    }
  }
}
</script>
<style scoped>
.table-unstriped {
  background-color: transparent;
}
.table-unstriped tbody tr {
  background-color: transparent;
}
.table-unstriped tbody tr td {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/NotificationList.vue